import React, { useEffect } from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import Logo from "../assets/images/logo.png";
import Google from "../assets/images/google.svg";
import Apple from "../assets/images/apple.svg";
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";


function SignIn() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const verified = params.get("verified");
  const [error, setError] = React.useState('');
  const [username, setUsername] = React.useState('');
  useEffect(() => {
    if (!verified) return;

    if (verified === "success") {
      Swal.fire({
        icon: "success",
        title: "Email Verified",
        text: "Your email has been successfully verified. You can now log in.",
        confirmButtonText: "OK",
      });
    }

    if (verified === "failed") {
      Swal.fire({
        icon: "error",
        title: "Verification Failed",
        text: "The verification link is invalid or expired.",
        confirmButtonText: "OK",
      });
    }

    if (verified === "missing") {
      Swal.fire({
        icon: "warning",
        title: "Missing Token",
        text: "Verification token is missing.",
        confirmButtonText: "OK",
      });
    }

    if (verified === "already") {
      Swal.fire({
        icon: "info",
        title: "Already Verified",
        text: "This email has already been verified. You can log in.",
      });
    }

  }, [verified]);



  const handleContinue = () => {
    if (username) {
      setError('');
      navigate("/sign-in-continue", { state: { username } });
    } else {
      setError('Username is required');
    }
  };

  return (
    <div className="login-sign-main common-padding" >
      <Container>
        <Card>
          <div className="login-sign-wrap">
            <img width={200} src={Logo} alt="" />
            <h3>Signin</h3>
          </div>

          <Form>
            <Form.Group controlId="formBasicEmail">
              <Form.Control type="text" placeholder="Enter username" value={username} onChange={(e) => setUsername(e.target.value)} />
            </Form.Group>

            <Button className="custom-bttn style-3 w-100 mt-3" onClick={handleContinue}>
              Continue
            </Button>
            <p className="text-danger">
              {error}
            </p>

            <p>
              New to Jambobay?{" "}
              <a href="/create-account">
                Create account
              </a>
            </p>
                        <div className="text-center or-div"> </div>


            {/* <div
              className="text-center or-div"
            >
              <span>
                OR
              </span>
            </div>

            <Button className="custom-bttn style-2 w-100 mb-3">
              <img src={Google} alt="" />
              Continue with Google
            </Button>

            <Button className="custom-bttn style-2 w-100">
              <img src={Apple} alt="" />
              Continue with Apple
            </Button> */}

            <p className="mb-0">
              By submitting, I accept RealEstate{" "}
              <a href="/terms-of-use">
                terms of use
              </a>
            </p>
          </Form>
        </Card>
      </Container>
    </div>
  );
}

export default SignIn;
